export const testimonials = [
  {
    id: 1,
    name: "Michael R.",
    location: "Cedar Hill, TX",
    service: "Plumbing Repair",
    rating: 5,
    text: "Jerry's team showed up same-day for a busted pipe emergency. Fixed it fast, cleaned everything up, and the price was fair. Couldn't ask for better plumbing service in the DFW area.",
  },
  {
    id: 2,
    name: "Sandra K.",
    location: "Fort Worth, TX",
    service: "Water Heater Replacement",
    rating: 5,
    text: "Had my water heater replaced and they were professional from start to finish. Showed up on time, explained everything clearly, and the new unit has been working perfectly. Highly recommend!",
  },
  {
    id: 3,
    name: "David T.",
    location: "Arlington, TX",
    service: "Drain Cleaning",
    rating: 5,
    text: "Very reliable and honest service. They diagnosed the issue with my sewer line quickly and gave me a straight answer on cost. No upselling, just solid workmanship.",
  },
  {
    id: 4,
    name: "Lisa M.",
    location: "Mansfield, TX",
    service: "Slab Leak Repair",
    rating: 5,
    text: "Discovered a slab leak on a Friday afternoon — Jerry's came out the same evening. The detection was precise, the repair was clean. These guys really know their craft.",
  },
  {
    id: 5,
    name: "Carlos V.",
    location: "Grand Prairie, TX",
    service: "Gas Line Repair",
    rating: 5,
    text: "Fast, professional, and fixed the issue right away. I smelled gas and called them immediately. They were at my door within the hour, identified the leak, and had it repaired safely.",
  },
  {
    id: 6,
    name: "Tamara J.",
    location: "Irving, TX",
    service: "Grease Trap Installation",
    rating: 5,
    text: "We needed a grease trap installed for our restaurant and Jerry's handled the whole project seamlessly. Great communication, professional crew, and done on schedule.",
  },
];
